import { createFileRoute } from "@tanstack/react-router";
import RacketTrekkenOrganiseren from "@/pages/RacketTrekkenOrganiseren";

export const Route = createFileRoute("/racket-trekken-organiseren")({
  head: () => ({
    meta: [
      { title: "Racket trekken organiseren bij je tennisclub | De Hussel- en Toss App" },
      { name: "description", content: "Organiseer racket trekken bij je tennisclub zonder gedoe. Slimme automatische indeling op basis van niveau en gespeelde rondes. Geen vrijwilligers nodig." },
      { property: "og:title", content: "Racket trekken organiseren bij je tennisclub | De Hussel- en Toss App" },
      { property: "og:description", content: "Organiseer racket trekken bij je tennisclub zonder gedoe. Slimme automatische indeling op basis van niveau en gespeelde rondes. Geen vrijwilligers nodig." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://dehusselapp.nl/racket-trekken-organiseren" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://dehusselapp.nl/racket-trekken-organiseren" }],
  }),
  component: RacketTrekkenOrganiseren,
});
